import $ from "jquery"

$('.js-foryour-item-label').each(function(){
    $(this).on('click', function(){
        const forYourDescription = $(this).closest('.js-foryour-item-box').find('.foryours__item-description').html();

        $('.js-foryour-item-description').html(forYourDescription);
        $('.js-foryour-item-box').removeClass('active');
        
        $(this).closest('.js-foryour-item-box').addClass('active');
    });
});